module.exports = __webpack_public_path__ + "resources/img/img_kollus_live_commerce_service1.f58261a42d48e72e2370c9be1e7b0780.png";